import React, { useEffect,useState } from "react";
import Homeproduct from "../../components/HomeProductCard/Homeproduct";
import "./Home.css";
import "aos/dist/aos.css";
import AOS from "aos";

import "swiper/css";
import "swiper/css/navigation";
import ReviewSection from "../../components/reviews/Review";

import PricingComparison from "../../components/pricing/Pricing";
import ManageSection from "../../components/HomeProductCard/Manage";
import HowItWorks from "../../components/HomeProductCard/HowitWorks";
import FeaturedResorts from "../../components/HomeProductCard/FeaturedResorts";
import BlogPage from "../../components/blog/Blog";




const Home = () => {

   const [openModal, setOpenModal] = useState(false);

     useEffect(() => {
       const timer = setTimeout(() => {
         setOpenModal(true);
       }, 3000); // 2 seconds

       return () => clearTimeout(timer); // cleanup
     }, []);

  useEffect(() => {
    AOS.init();
    window.scrollTo(0, 0);
  }, []);

  const data = [

    { imgUrl: "/images/homebanner1.png" },
    { imgUrl: "/images/mobile_banner.png" },

  ];

  return (
    <div className="">
      {/* Single Success Story Slider */}
      <div className="w-full">
        {/* Desktop Banner */}
        <img
          src="/images/homebanner1.png"
          alt="Desktop Banner"
          className="hidden md:block w-full md:h-[700px] h-auto object-cover rounded-lg"
          loading="lazy"
        />

        {/* Mobile Banner */}
        <img
          src="/images/mobile_banner.png"
          alt="Mobile Banner"
          className="block md:hidden w-full h-[480px] object-cover rounded-lg"
          loading="lazy"
        />
      </div>

      {/* <ConsultationModal
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
      /> */}

      <PricingComparison />
      {/* <LastVisitedProduct /> */}
      <FeaturedResorts />
      <Homeproduct />
      <ManageSection />
      <HowItWorks />
      <BlogPage />
      <ReviewSection />
    </div>
  );
};

export default Home;
